import { IsNotEmpty, IsString } from 'class-validator';

export class SourceIdParamsDto {
  @IsString()
  @IsNotEmpty()
  sourceId!: string;
}
